module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_txt2_m_en.ce75dd0d23a994df991b2f21f97f7ea4.png";